import { Deserializable } from '../_common/deserializable';

export class Affiliate implements Deserializable {
      id: number;
      keywordId: number;
      shortCode: string;
      keyword: string;
      operator: string;
      affiliate: string;
      moNotifyUrl: string;
      dnNotifyUrl: string;
      cnvUrl: string;
      moMin: number;
      dnMin: number;
      cnvMin: number;
      moCap: number;
      dnCap: number;
      cnvCap: number;
      createdAt: string;
      moPostBackRate:  number;
      dnPostBackRate: number;
      cnvPostBackRate: number;
      managerId: number;
      share: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
